import { FormInstance } from 'antd';
import { JobOptionSvc, JobSpec } from 'domains/jobconfigDomain';
import { SKU } from 'domains/skuDomain';
import React, { ElementType } from 'react';
import Banners from './components/Banners';
import Binder from './components/Binder';
import BookletsSaddleStitched from './components/BookletsSaddleStitched';
import Bundling from './components/Bundling';
import CarbonlessAdhesive from './components/CarbonlessAdhesive';
import Chipboard22pt from './components/Chipboard22pt';
import Collating from './components/Collating';
import CornerStaple from './components/CornerStaple';
import CrashNumbering from './components/CrashNumbering';
import DefaultSvc from './components/DefaultSvc';
import DieCut from './components/DieCut';
import Drilling from './components/Drilling';
import EmbossDeboss from './components/EmbossDeboss';
import Foil from './components/Foil';
import Fulfillment from './components/Fulfillment';
import HandWork from './components/HandWork';
import Inserting from './components/Inserting';
import LaminateFlushCut from './components/LaminateFlushCut';
import LaminatePouch from './components/LaminatePouch';
import LaminateSealedEdge from './components/LaminateSealedEdge';
import MountedPosters from './components/MountedPosters';
import MountedPostersFrench from './components/MountedPostersFrench';
import PaddingAdhesive from './components/PaddingAdhesive';
import PerfectBound from './components/PerfectBound';
import Perforate from './components/Perforate';
import PlasticCoil from './components/PlasticCoil';
import PlasticComb from './components/PlasticComb';
import PostcardsSelfMailersLettersMailListOptions from './components/PostcardsSelfMailersLettersMailListOptions';
import PostcardsSelfMailersLettersPostage from './components/PostcardsSelfMailersLettersPostage';
import Prepress from './components/Prepress';
import ProClick from './components/ProClick';
import RoundCornering from './components/RoundCornering';
import Score from './components/Score';
import SelfMailers from './components/SelfMailers';
import TapeBind from './components/TapeBind';
import UVCoating from './components/UVCoating';
import WireLoop from './components/WireLoop';
import './index.less';

interface Props {
  revxTypeId: number;
  revxId: number;
  [x: string]: any;
  id: number;
  isOneof?: boolean;
}

export interface ConfigSvcProps extends Props {
  form: FormInstance<any>;
  formCache: { [x: string]: any };
  jobOptionSvc: JobOptionSvc;
  jobOptionSvcs: JobOptionSvc[];
  isRequired: boolean;
  sku: SKU;
  spec: JobSpec;
  disabled?: boolean;
  show?: boolean;
  isSku?: boolean;
}

const ConfigSvcDetail = ({ revxTypeId, revxId, ...props }: Props) => {
  const componentList = [
    {
      revxTypeId: [1],
      revxId: [55],
      component: BookletsSaddleStitched,
    },
    {
      revxTypeId: [1],
      revxId: [42],
      component: PlasticCoil,
    },
    {
      revxTypeId: [1],
      revxId: [43],
      component: PlasticComb,
    },
    {
      revxTypeId: [1],
      revxId: [56],
      component: TapeBind,
    },
    {
      revxTypeId: [1],
      revxId: [59],
      component: WireLoop,
    },
    {
      revxTypeId: [1],
      revxId: [51],
      component: ProClick,
    },
    {
      revxTypeId: [1],
      revxId: [41],
      component: PerfectBound,
    },
    {
      revxTypeId: [1],
      revxId: [54],
      component: CornerStaple,
    },
    {
      revxTypeId: [1],
      revxId: [62, 63],
      component: Binder,
    },
    {
      revxTypeId: [10],
      revxId: [29],
      component: MountedPosters,
    },
    {
      revxTypeId: [20],
      revxId: [32],
      component: PostcardsSelfMailersLettersPostage,
    },
    {
      revxTypeId: [19],
      revxId: [30, 31],
      component: PostcardsSelfMailersLettersMailListOptions,
    },
    {
      revxTypeId: [24],
      revxId: [57],
      component: SelfMailers,
    },
    {
      revxTypeId: [2],
      revxId: [22],
      component: LaminateFlushCut,
    },
    {
      revxTypeId: [2],
      revxId: [24],
      component: LaminateSealedEdge,
    },
    {
      revxTypeId: [2],
      revxId: [23],
      component: LaminatePouch,
    },
    {
      revxTypeId: [2],
      revxId: [61],
      component: UVCoating,
    },
    {
      revxTypeId: [18],
      revxId: [16],
      component: Score,
    },
    {
      revxTypeId: [11],
      revxId: [64],
      component: DieCut,
    },
    {
      revxTypeId: [11],
      revxId: [65],
      component: EmbossDeboss,
    },
    {
      revxTypeId: [11],
      revxId: [66],
      component: Foil,
    },
    {
      revxTypeId: [18],
      revxId: [15],
      component: Perforate,
    },
    {
      revxTypeId: [10],
      revxId: [28],
      component: MountedPostersFrench,
    },
    {
      revxTypeId: [10],
      revxId: [26, 27],
      component: Banners,
    },
    {
      revxTypeId: [13],
      revxId: [1, 2, 3, 4, 5],
      component: Bundling,
    },
    {
      revxTypeId: [5],
      revxId: [9],
      component: Drilling,
    },
    {
      revxTypeId: [11],
      revxId: [69],
      component: RoundCornering,
    },
    {
      revxTypeId: [3],
      revxId: [6],
      component: Collating,
    },
    {
      revxTypeId: [8],
      revxId: [18, 19],
      component: HandWork,
    },
    {
      revxTypeId: [9],
      revxId: [21],
      component: Inserting,
    },
    {
      revxTypeId: [14],
      revxId: [17],
      component: Fulfillment,
    },
    {
      revxTypeId: [12],
      revxId: [35],
      component: CrashNumbering,
    },
    {
      revxTypeId: [17],
      revxId: [38],
      component: CarbonlessAdhesive,
    },
    {
      revxTypeId: [17],
      revxId: [39],
      component: PaddingAdhesive,
    },
    {
      revxTypeId: [17],
      revxId: [40],
      component: Chipboard22pt,
    },
    {
      revxTypeId: [22],
      revxId: [47, 48, 49, 50],
      component: Prepress,
    },
  ];

  const errorPage = (page: ElementType<any>, props: any) => {
    if (page) {
      return React.createElement(page, { ...props });
    } else {
      return 'error page';
    }
  };

  const renderDom = () => {
    const filterComponent = componentList.find(
      (item) =>
        item.revxTypeId.includes(revxTypeId) && item.revxId.includes(revxId)
    );
    if (filterComponent) {
      return errorPage(filterComponent.component, props);
    } else {
      return errorPage(DefaultSvc, props);
    }
  };

  return <>{renderDom()}</>;
};

export default ConfigSvcDetail;
